module.exports = __webpack_public_path__ + "resources/img/img_datahunt2_jp.bad97689e343a3a74a793d2bb5083569.png";